<template>
  <li :class="{ submenu: item.submenu }">
    <template v-if="item.can_show !== false">
      <a v-if="item.submenu && !item.link" href="javascript:void(0);">
        <i :class="item.icon" v-if="item.icon"></i>
        <span>{{ item.mainMenu || item.label }}</span>
        <span v-if="item.submenu" class="menu-arrow"></span>
      </a>
      <router-link
        v-else
        :to="{ name: item.link }"
        :class="{ active: item.link === currentPath }"
        :target="item?.new_tab ? '_blank' : '_self'"
        v-if="!item.can || (item.can && user.permissions[item.can])"
      >
        <i :class="item.icon" v-if="item.icon"></i>
        <span>{{ item.mainMenu || item.label }}</span>
      </router-link>
      <ul v-if="item.submenu && item.submenuItems">
        <menu-item
          v-for="(subItem, index) in item.submenuItems"
          :key="index"
          :item="subItem"
          :current-path="currentPath"
          :user="user"
        />
      </ul>
    </template>
  </li>
</template>

<script>
export default {
  name: "MenuItem",
  props: {
    item: {
      type: Object,
      required: true,
    },
    currentPath: {
      type: String,
      default: "",
    },
    user: {
      type: Object,
      required: true,
    },
  },
};
</script>
